export default __webpack_public_path__ + "53b0546d97d0ca8eb456c2e61cf7b240.png";